document.addEventListener('DOMContentLoaded', function() {
  const isMobile = window.matchMedia('(max-width: 749px)').matches;

  if (isMobile) {
    setupMobileCarousel();
    return;
  }

  // Check if GSAP and ScrollTrigger are loaded
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP or ScrollTrigger not loaded, falling back to native scroll');
    setupNativeScroll();
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  const historyWrapper = document.querySelector('#history-wrapper');
  const historySlider = document.querySelector('#history-slider');
  const historyItems = document.querySelectorAll('.history-content-item');
  const tabs = document.querySelectorAll('.history-title-tab');

  if (!historyWrapper || !historySlider || historyItems.length === 0) {
    console.warn('History elements not found');
    return;
  }

  const sliderScrollWidth = historySlider.scrollWidth;
  const viewportWidth = window.innerWidth;
  const scrollDistance = sliderScrollWidth - viewportWidth;

  gsap.to(historySlider, {
    x: -scrollDistance,
    ease: "none",
    scrollTrigger: {
      trigger: historyWrapper,
      start: "top top",
      end: () => `+=${scrollDistance}`,
      scrub: 1,
      pin: true,
      anticipatePin: 1,
      onUpdate: self => {
        updateActiveTab(self.progress);
      }
    }
  });

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      const progress = index / (historyItems.length - 1);
      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: historyWrapper.offsetTop + (progress * scrollDistance)
        }
      });
    });
  });

  function updateActiveTab(progress) {
    const activeIndex = Math.round(progress * (historyItems.length - 1));
    tabs.forEach((tab, index) => {
      tab.classList.toggle('active', index === activeIndex);
    });
  }

  if (tabs.length > 0) {
    tabs[0].classList.add('active');
  }
});

// Fallback native scroll function (desktop, no GSAP)
function setupNativeScroll() {
  const historyWrapper = document.querySelector('#history-wrapper');
  const historySlider = document.querySelector('#history-slider');
  const historyItems = document.querySelectorAll('.history-content-item');
  const tabs = document.querySelectorAll('.history-title-tab');

  if (!historyWrapper || !historySlider || historyItems.length === 0) return;

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      const scrollPosition = index * window.innerWidth;
      historyWrapper.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    });
  });

  historyWrapper.addEventListener('scroll', () => {
    const maxScroll = historySlider.scrollWidth - historyWrapper.clientWidth;
    const scrollProgress = historyWrapper.scrollLeft / maxScroll;
    const activeIndex = Math.round(scrollProgress * (historyItems.length - 1));
    tabs.forEach((tab, index) => {
      tab.classList.toggle('active', index === activeIndex);
    });
  });

  if (tabs.length > 0) {
    tabs[0].classList.add('active');
  }
}

// Mobile: scroll-snap carousel on #history-slider, dots via IntersectionObserver
function setupMobileCarousel() {
  const slider = document.querySelector('#history-slider');
  const items = slider ? [...slider.children] : [];
  const tabs = document.querySelectorAll('.history-title-tab');

  if (!slider || items.length === 0) return;

  const setActive = (index) => {
    tabs.forEach((tab, i) => tab.classList.toggle('active', i === index));
  };

  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => {
      items[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActive(items.indexOf(entry.target));
        }
      });
    },
    { root: slider, threshold: 0.6 }
  );

  items.forEach((item) => observer.observe(item));
  setActive(0);
}